<template>
  <div class="table-header">
    <div class="d-flex flex-wrap gap-2">
      <slot class="custom-slot" />
      <snow-button
        v-if="add"
        variant="borderless"
        size="sm"
        @click="$emit('add')"
        :disabled="disableAdd"
        icon="ph ph-plus"
      >
        {{ addText }}
      </snow-button>
      <snow-button
        v-if="filters"
        size="sm"
        variant="borderless"
        icon="ph ph-funnel-simple"
        @click="$emit('open-filters')"
      />
      <snow-export-button
        v-if="
          exportOptions &&
            exportOptions.action &&
            $permissions.hasPermission(exportOptions.permission)
        "
        ref="exportButton"
        :action="exportOptions.action"
        :filters="exportOptions.filters"
        :filename="exportOptions.filename"
        :disabled="exportOptions.disabled"
        :label="exportOptions.label"
        :confirmation="exportOptions.confirmation"
        @select="() => $emit('select')"
      />
    </div>
    <div
      v-if="search || datePicker"
      class="d-flex flex-lg-row flex-column align-items-center justify-content-end gap-2 mt-lg-0 mt-4"
    >
      <snow-search
        v-if="search"
        v-model="searchQuery"
        @search="search => $emit('searching', search)"
      />
      <snow-date-picker
        v-if="datePicker"
        :value="dates"
        @input="dates => $emit('dates', dates)"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import SnowExportButton from "@/components/snow-ui/SnowExportButton.vue";
import SnowDatePicker from "@/components/snow-ui/SnowDatePicker.vue";
export default {
  components: { SnowExportButton, SnowDatePicker },
  props: {
    search: {
      type: Boolean,
      default: true
    },
    dates: {
      type: Array,
      default: () => ["", ""]
    },
    add: {
      type: Boolean,
      default: true
    },
    filters: {
      type: Boolean,
      default: true
    },
    datePicker: {
      type: Boolean,
      default: true
    },
    addText: {
      type: String,
      default: "Adicionar"
    },
    disableAdd: {
      type: Boolean,
      default: false
    },
    disabled_tooltip_msg: {
      type: String,
      default: ""
    },
    exportOptions: {
      type: Object,
      default: () => ({
        action: null,
        filters: {},
        filename: "export_data",
        disabled: false,
        label: "Exportar",
        confirmation: false,
        permission: "export_data"
      })
    }
  },
  data() {
    return {
      searchQuery: ""
    };
  },
  computed: {
    ...mapState("integration", ["pagination"])
  }
};
</script>
<style lang="scss" scoped>
.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--bg-2);
  padding: 8px !important;
  border-radius: 8px;

  @media screen and (max-width: 991px) {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>
